import {Injectable} from "@angular/core";
import {ActivatedRouteSnapshot, Resolve} from "@angular/router";
import {Observable} from "rxjs";
import {LeadDgSearchResults} from "../models/datagrid-search-results/lead.dg-search-results.model";
import {LeadService} from "../providers/lead.service";
import {AppStateService} from "../providers/app-state.service";
import {tap} from "rxjs/operators";
import {environment} from "../../environments/environment";

@Injectable()
export class LeadsResolve implements Resolve<LeadDgSearchResults> {
  constructor(private leadService: LeadService, private appStateService: AppStateService) {}

  resolve(route: ActivatedRouteSnapshot): Observable<LeadDgSearchResults> {
    this.appStateService.updateIsBusySubject(true);
    return this.leadService.getResults( environment.DEFAULT_RESULTS_LIMIT,0,'DESC','created').pipe(tap(res => {
      this.appStateService.updateIsBusySubject(false);
    }));
  }
}
